import { ContactsService, InitContactDialogInput } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type InitContactDialogInputVariables = {
  requestBody?: InitContactDialogInput;
};
export const useContactsInitContactDialogMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof ContactsService.postContactsInitContactDialog>>,
      QueryError,
      InitContactDialogInputVariables,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ requestBody }: InitContactDialogInputVariables) => ContactsService.postContactsInitContactDialog(requestBody),
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
